export default "__VITE_ASSET__CuWEKvz9__"